<template>
  <article
    class="sli-location sli-inv-card"
    :class="index % 2 === 0 ? 'is-navy' : 'is-lime'"
  >
    <div class="sli-inv-card__body">
      <div class="sli-inv-card__main">
        <h4 class="sli-inv-card__title">
          {{ item.subject_name || '—' }}
        </h4>
        <p class="sli-inv-card__meta">
          كود الأرض: {{ item.land_code || '—' }}
          <span v-if="item.shahr_number"> — شهر {{ item.shahr_number }}</span>
        </p>
        <p class="sli-inv-card__meta">
          الموقع: {{ locationLabel }}
        </p>
        <div class="sli-inv-card__badges">
          <span class="sli-chip">عدد القطع {{ lands }}</span>
          <span class="sli-chip">عدد التعديات {{ encroachments }}</span>
          <span class="sli-chip">مربوط {{ linked }}</span>
        </div>
      </div>
      <div class="sli-inv-card__actions">
        <router-link
          class="sli-save sli-save--sm"
          :to="showTo"
        >
          عرض التفاصيل
        </router-link>
        <router-link
          v-if="canEdit"
          class="sli-text-link"
          :to="editTo"
        >
          تعديل
        </router-link>
        <router-link
          class="sli-text-link"
          :to="showTo"
        >
          إنشاء مشروع تعدي
        </router-link>
        <button
          v-if="canLink"
          type="button"
          class="sli-text-link"
          :disabled="busy"
          @click="$emit('link', item)"
        >
          ربط الاستيلاء
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import {
  landsCount,
  encroachmentsCount,
  linkedParcelsCount,
  canLinkSeizure,
  inventoryLocationLabel,
} from '../formModel'

export default {
  name: 'SliInventoryCard',
  props: {
    item: { type: Object, required: true },
    index: { type: Number, default: 0 },
    busy: { type: Boolean, default: false },
    tab: { type: String, default: '' },
  },
  computed: {
    lands() {
      return landsCount(this.item)
    },
    encroachments() {
      return encroachmentsCount(this.item)
    },
    linked() {
      return linkedParcelsCount(this.item)
    },
    canLink() {
      return canLinkSeizure(this.item)
    },
    locationLabel() {
      return inventoryLocationLabel(this.item)
    },
    canEdit() {
      return this.hasPermission('edit seizure_land_inventories')
    },
    showTo() {
      return {
        name: 'seizure-land-inventories-show',
        params: { id: this.item.id },
        query: this.tab ? { tab: this.tab } : {},
      }
    },
    editTo() {
      return {
        name: 'seizure-land-inventories-edit',
        params: { id: this.item.id },
        query: this.tab ? { tab: this.tab } : {},
      }
    },
  },
}
</script>

<style scoped>
.sli-inv-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.sli-inv-card__body {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  gap: 12px 16px;
  height: 100%;
  padding: 14px 16px;
}
.sli-inv-card__main {
  min-width: 0;
  flex: 1 1 auto;
}
.sli-inv-card__actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 8px;
  flex: 0 0 132px;
}
.sli-inv-card__actions .sli-save--sm,
.sli-inv-card__actions .sli-text-link {
  text-align: center;
}
.sli-inv-card__actions .sli-text-link {
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
}
@media (max-width: 575.98px) {
  .sli-inv-card__body {
    flex-direction: column;
  }
  .sli-inv-card__actions {
    flex: 1 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }
  .sli-inv-card__actions .sli-save--sm {
    flex: 1 1 100%;
  }
}
</style>
